'use strict';

import { Component } from 'react';
import { connectCurrentRefinements, HierarchicalMenu, RefinementList, SearchBox, ToggleRefinement } from 'react-instantsearch-dom';
import WhenRefinable from './WhenRefinable';
import CourseStatusFilter from './CourseStatusFilter';

const ClearFilters = connectCurrentRefinements(({ items, refine }) => {
	if (! items.length) {
		return null;
	}
	
	return (
		<div className="mt-3">
			<button
				type="button"
				className="ais-ClearRefinements-button"
				onClick={ () => refine(items) }
			>
				Clear all filters
			</button>
		</div>
	);
});

export default class Filters extends Component {
	render() {
		const { className = '' } = this.props;
		
		return (
			<div className={ `${ className } w-full` }>
				<h4 className="mt-0 mb-2">
					Search Courses
				</h4>
				
				<SearchBox autoFocus={ true } />
				
				<ClearFilters clearsQuery={ true } />
				
				<CourseStatusFilter />
				
				<WhenRefinable attribute="approvals.generic_name" className="mb-4">
					<h4 className="mt-8 mb-1">
						Approved By
					</h4>
					<p className="m-0">
						Narrow down to just courses approved in your region or by a specific provider.
					</p>
				</WhenRefinable>
				
				<HierarchicalMenu
					attributes={ ["approval_levels.lvl0", "approval_levels.lvl1", "approval_levels.lvl2", "approval_levels.lvl3"] }
					limit={ 999 }
					showMore={ true }
					showMoreLimit={ 999 }
					showParentLevel={ false }
					transformItems={ items => items
						.sort((a, b) => {
							const label_a = a.label.toLowerCase();
							const label_b = b.label.toLowerCase();
							
							// Sort US and Canada to the top
							if ('united states' === label_a) {
								return -1;
							}
							if ('canada' === label_a) {
								return -1;
							}
							
							// Then sort alphabetically
							if (label_a < label_b) {
								return -1;
							}
							if (label_a > label_b) {
								return 1;
							}
							
							return 0;
						})
						.map(lvl0 => {
							if (Array.isArray(lvl0.items)) {
								lvl0.items = lvl0.items.sort((a, b) => {
									const label_a = a.label.toLowerCase();
									const label_b = b.label.toLowerCase();
									
									if (`all of ${ lvl0.label }`.toLowerCase() === label_a) {
										return -1;
									}
									
									// Then sort alphabetically
									if (label_a < label_b) {
										return -1;
									}
									if (label_a > label_b) {
										return 1;
									}
									
									return 0;
								});
							}
							return lvl0;
						}) }
				/>
				
				{/*
				<RefinementList
					attribute="approvals.generic_name"
					searchable
					limit={ 10 }
					showMore={ true }
					showMoreLimit={ 500 }
					transformItems={ items => {
						return items.sort((a, b) => {
							const aState = a.label.toUpperCase();
							const bState = b.label.toUpperCase();
							
							// Move checked to the top
							if (a.isRefined && ! b.isRefined) {
								return -1;
							} else if (b.isRefined && ! a.isRefined) {
								return 1;
							}
							
							return aState < bState ? -1 : aState > bState ? 1 : 0;
						}).map(item => {
							let label = item.label;
							if (label.length > 33) {
								label = label.substr(0, 30) + '...';
							}
							return { ...item, label };
						});
					} }
				/>
				
				<WhenRefinable attribute="approvals.department_type" className="mb-4">
					<h4 className="mt-8 mb-1">
						Approval Type
					</h4>
					<p className="m-0">
						Regions can have many types of approvals. Narrow down to just the ones you’re looking for.
					</p>
				</WhenRefinable>
				<RefinementList attribute="approvals.department_type" />
				*/ }
				
				<WhenRefinable attribute="category" className="mb-4">
					<h4 className="mt-8 mb-0">
						Category
					</h4>
				</WhenRefinable>
				<RefinementList attribute="category" searchable showMore={ true } limit={ 7 } showMoreLimit={ 500 } />
				
				<WhenRefinable attribute="audience" className="mb-4">
					<h4 className="mt-8 mb-1">
						Audience
					</h4>
					<p className="m-0">
						InterNACHI® has <em>many</em> courses. Find ones made for you (regardless of CE approvals).
					</p>
				</WhenRefinable>
				<RefinementList attribute="audience" />
				
				<WhenRefinable attribute="language" className="mb-4">
					<h4 className="mt-8">
						Language
					</h4>
				</WhenRefinable>
				<RefinementList attribute="language" />
				
				<h4 className="my-4 mt-8">
					Other Filters
				</h4>
				
				<ToggleRefinement
					attribute="cpi_requirement"
					label="Required for CPI&reg; certification"
					value={ true }
				/>
				
				<ToggleRefinement
					attribute="available_to_non_members"
					label="Free to guests"
					value={ true }
				/>
			</div>
		);
	}
}
